<template>
  <div>
    <a :href="appLinks.apple">
        <img src="~assets/images/brochure/patient/ios.png">
    </a>
    <a :href="appLinks.andriod">
        <img src="~assets/images/brochure/patient/android.png">
    </a>
  </div>
</template>

<script>
  export default {
    name: 'app-links',
    props: {
      appLinks: {
        type: Object,
        default: {
          apple: null,
          andriod: null,
        },
      },
    },
  };
  
</script>



// WEBPACK FOOTER //
// AppLinks.vue?7b7c12b5